"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformCasing = void 0;
const camelCase_1 = __importDefault(require("lodash/camelCase"));
const snakeCase_1 = __importDefault(require("lodash/snakeCase"));
const merge_1 = __importDefault(require("lodash/merge"));
const transformCasing = (data, casingFunc) => {
    if (typeof data !== 'object' || !data) {
        return data;
    }
    if (Array.isArray(data)) {
        return data.map(d => (0, exports.transformCasing)(d, casingFunc));
    }
    return Object.entries(data).reduce((acc, [key, value]) => {
        if (typeof value === 'object' && value) {
            acc[casingFunc(key)] = (0, merge_1.default)((0, exports.transformCasing)(value, snakeCase_1.default), (0, exports.transformCasing)(value, camelCase_1.default));
        }
        else {
            acc[casingFunc(key)] = value;
        }
        return acc;
    }, {});
};
exports.transformCasing = transformCasing;
